import { dirtifyErreur, type Dirty, type ErreurWithDirty } from '@/features/application/dirty'
import type { Erreur, Level } from '@/features/domaine/moteur-regles'
import { shallowRef } from 'vue'

export function useErreurDirtyState<TModel extends object, TLevel extends Level = Level>() {
  const state = shallowRef<ErreurWithDirty<TModel, TLevel>>({})

  function dirtify(erreur: Erreur<TModel, TLevel>, dirty: Dirty<TModel>) {
    state.value = dirtifyErreur<TModel, TLevel>(erreur, dirty)
  }

  function $reset() {
    state.value = {
      $estDirty: false,
      $estErreur: false,
      $level: null,
      $origine: null,
      $estErreurDirty: false,
      $messageErreur: null,
      $messageErreurDirty: null,
    } as ErreurWithDirty<TModel, TLevel>
  }

  return {
    state,
    dirtify,
    $reset,
  }
}

